import React from 'react';

import { Home } from '@entities/home';

const HomePage = () => {
	return <Home />;
};

export default HomePage;
